import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCO-hasCrJVbdE2w7fIxyHZh6Ej1jZzvrs",
  authDomain: "bigode-app-fade.firebaseapp.com",
  projectId: "bigode-app-fade",
  storageBucket: "bigode-app-fade.firebasestorage.app",
  messagingSenderId: "611404185255",
  appId: "1:611404185255:web:578127f396f40ac010a582",
  measurementId: "G-DEZEDCJJJ5"
};

// Inicializa o app (ESSENCIAL)
const app = initializeApp(firebaseConfig);

// Exporta corretamente
export { app };